import { useRoutes } from "react-router-dom";
import DashboardRoutes from "../../routes/DashboardRoutes";

const DashboardRouting = () => {
  const routing = useRoutes(DashboardRoutes);

  return routing;
};

export default DashboardRouting;